import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Constants } from '@constants';
import { ServiceAgreementStatus } from '@fs/enums/agreement-state.enum';
import { AgreementResponseModel } from '@fs/models/agreement/response.model';
import { AgreementService } from '@fs/services/agreement/agreement.service';
import { FsUtil } from '@fs/services/fs-utils';
import { TabParams } from '@fs/services/tab-params.service';
import { CommonMethods } from '@services/common.method';
import { PrintService } from '@services/print-layout.service';
import { TabOpenService } from '@services/tab-open.service';
import { NotificationsService } from '@shared/services/notification';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { ActionName } from '@shared/enums/action-name';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonService } from '@shared/services/common.service';
import { AuthService } from '@services/auth.service';
import { WorkOrderModel } from '@fs/models/work-order/work-order.model';
import { Tabs } from '@enums/tab.enum';
import { DataSharingLTE } from '@fs/services/data-sharing-lte.service';
import { EvetnEmitModel } from '@shared/models/event-emit.model';
import { VisitEmitType } from '@fs/models/agreement/visit.model';
import { VisitStatus } from '@fs/enums/visit-state.enum';

@Component({
  selector: 'agreement-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss'],
  providers: [AgreementService]
})
export class SaViewComponent implements OnInit {
  showEquipment: boolean = false;
  status: ServiceAgreementStatus;
  statusCodes = ServiceAgreementStatus; 
  data: AgreementResponseModel;
  private initialData: any;

  private readonly ngUnsubscribe = new Subject();
  private set _data(val) {
    this.data = val;
    this.status = ServiceAgreementStatus[val.AgreementStatus.toLowerCase() as keyof typeof ServiceAgreementStatus];
    if (!this.data.OriginatingWorkticket)
      this.data.OriginatingWorkticket = new WorkOrderModel();
      
    this.data.OriginatingWorkticket.Customer = Object.assign({}, val.Customer);
  };
  cancelSettings = { ID: "", show: false };
  private tabCounter: number;
  private inputParams: any;
  public actionName = ActionName;

  public cancelationFormGroup: FormGroup;
  public suspendedFormGroup: FormGroup;
  public cancelReasonPopup: boolean = false;
  public suspendedReasonPopup: boolean = false;
  public confirmActionOkBtn: string = "";
  public confirmMessage: string = "";
  public serviceAgreementReasonLookup: any;
  public companyData: any;
  public workTicketCancelReasonLookup: any;
  public workTicketVoidReasonLookup: any;
  public showdropdownLoder: boolean = false;
  public showPostponeModal: boolean = false;
  public selectedVisit: any;

  constructor(private agreementServ: AgreementService, private spinnerServ: SpinnerService,
              private $viewContainerRef: ViewContainerRef, private toastServ: NotificationsService, 
              private tabOpenserv: TabOpenService, private commonMethods: CommonMethods, private printService: PrintService,
              private httpCommon: CommonService, private auth: AuthService, private dataShareServ: DataSharingLTE) { 
    this.dataShareServ.visitChangeEvent
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe((x: EvetnEmitModel<VisitEmitType>) => {
        if (x.Type == 'Status') {
          let visit = this.data.Visits.find(y => y.ID == x.ID);
          if (visit) {
            visit.Status = VisitStatus.Converted;
            visit.WorkTicketID = x.Value.WorkTicketID;
            visit.WoNumber = x.Value.WorkTicketNo;
          }
        }
      });
  }

  ngOnInit() {
    if (!FsUtil.checkNullOrUndefined([this.inputParams])) {
      if (this.inputParams.Load) {
        this.getAgreement(Constants.defaultSpinnertimeout);
      } else {
        this._data = this.inputParams.Data;
      }
      let http = this.httpCommon.GetIntialData( this.auth.getCompanyId(),
                  "WorkTicketCancelReasonLookup,WorkTicketVoidReasonLookup,CodeTypeData"
      )
      .subscribe(response => {
        this.initialData = response;
        this.companyData = response;
        this.workTicketCancelReasonLookup = this.initialData.WorkTicketCancelReasonLookup.filter(
          x => x.IsActive == true
        );
      }, error => {
        this.showdropdownLoder = false;
      });
    }
  }

  
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  refreshTab() {
    this.getAgreement();
  }
  getAgreement(spinnerTimeout: number = 0) {
    let http = this.agreementServ.GetAgreement(this.inputParams.JobSiteID, this.inputParams.ID);
    this.spinnerServ.showloader(this.$viewContainerRef, this.tabCounter, spinnerTimeout);
    this.setData(http);
  }
  changeStatus(code: ServiceAgreementStatus) {
    let data = {
      ID:this.inputParams.ID,
      ServiceAgreementStatus: null,
      CancelComment: "",
      CancellationReason: null,
      JobSiteID: this.inputParams.JobSiteID,
      CancelReasonID: CommonMethods.GetID(),
      ModifyDate : this.data.ModifyDate
    };
    if (this.confirmActionOkBtn == Constants.SAStaticStatus().CancelServiceAgreement) {
        data.ServiceAgreementStatus = code;
        data.CancellationReason = {
          ID: this.cancelationFormGroup.controls["CancellationReason"].value
        };
        data.CancelReasonID = this.cancelationFormGroup.controls["CancellationReason"].value;
        data.CancelComment = this.cancelationFormGroup.controls["CancellationComment"].value;
    } else if (this.confirmActionOkBtn == Constants.SAStaticStatus().SuspendServiceAgreement) {
        data.ServiceAgreementStatus = code;
        data.CancellationReason = { ID: this.suspendedFormGroup.controls["SuspensionReason"].value };
        data.CancelReasonID = this.suspendedFormGroup.controls["SuspensionReason"].value;
        data.CancelComment = this.suspendedFormGroup.controls["SuspensionComment"].value;
    }else {
      data.ServiceAgreementStatus = code;
    }
    let http = this.agreementServ.ChangeAgreementStatus(this.inputParams.JobSiteID, this.inputParams.ID, data);
    this.spinnerServ.showloader(this.$viewContainerRef, this.tabCounter, 0);
    this.setData(http, "Service Agreement "+ ServiceAgreementStatus[code] +" successfully");
    this.cancelReasonPopup = false;
    this.suspendedReasonPopup = false;
    this.confirmMessage = "";
    this.confirmActionOkBtn = "";
  }
  reasonPopupIntilize(code: ServiceAgreementStatus)  {
    if(code == 1){
      this.IntializeCancelationFrom();
      this.cancelReasonPopup = true;
    }else if(code == 2) {
      this.IntializeSuspendedFrom();
      this.suspendedReasonPopup=true;
    }
  }
  editAgreement() {
    this.tabOpenserv.ReplaceTab({
      CurrentTabIndex: this.tabCounter,
      newTabInfo: TabParams.EditServiceAgreement(this.data)
    });
  }
  openViewWorkOrder(obj) {
    obj['ID'] = obj.WorkTicketID;
    obj['Customer'] = { ID: this.data.Customer.ID };
    obj['JobSite'] = { ID: this.data.JobSite.ID };
    obj['WorkTicketNo'] = obj.WoNumber;

    let parmas = TabParams.ViewWorkOrder(obj);
    parmas['replaceIfOpen'] = {
      replaceTab: true,
      tabToReplace: Tabs.FsLiteWorkOrderEdit,
      action: "focus"
    }
    this.tabOpenserv.OpenTab(parmas);
  }
  openNewWorkOrder(e) {
    let parmas = {
      Visit: e,
      Customer: this.data.Customer,
      ServiceType: { ID: e.ServiceTypeID },
      PromisedDate: new Date(e.ProposedDate),
      DispatchComment: e.DispatchComment
    };
    parmas.Customer.JobSites = [this.data.JobSite];
    this.tabOpenserv.OpenTab(TabParams.NewWorkOrder(parmas));
  }
  private IntializeCancelationFrom() {
    this.cancelationFormGroup = new FormGroup({
      CancellationReason: new FormControl("", [Validators.required]),
      CancellationComment: new FormControl("", [
        this.commonMethods.noWhitespaceValidator
      ])
    });
  }
  private IntializeSuspendedFrom() {
    this.suspendedFormGroup = new FormGroup({
      SuspensionReason: new FormControl("", [Validators.required]),
      SuspensionComment: new FormControl("", [
        this.commonMethods.noWhitespaceValidator
      ])
    });
  }
  public CancelAgreement() {
    if (this.cancelationFormGroup.valid) {
      this.confirmActionOkBtn = Constants.SAStaticStatus().CancelServiceAgreement;
      this.changeStatus(ServiceAgreementStatus.cancelled);
    } else {
      this.commonMethods.markFormGroupTouched(this.cancelationFormGroup);
    }
  }
  public SuspendedAgreement() {
    if (this.suspendedFormGroup.valid) {
      this.confirmActionOkBtn = Constants.SAStaticStatus().SuspendServiceAgreement;
      this.changeStatus(ServiceAgreementStatus.suspended);
    } else {
      this.commonMethods.markFormGroupTouched(this.suspendedFormGroup);
    }
  }
  public CloseCancelReasonPopup() {
    this.cancelReasonPopup = false;
  }
  public CloseSuspendedReasonPopup() {
    this.suspendedReasonPopup = false;
  }
  print() {
    this.spinnerServ.showloader(this.$viewContainerRef, this.tabCounter, 0);
    this.agreementServ.PrintAgreement(this.inputParams.ID)
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe(response => {
        this.printService.PrintURL(this.commonMethods.GetDocumentPrintURL(response));
        this.spinnerServ.hideLoader(this.$viewContainerRef, this.tabCounter);
    },
    error => {
        this.spinnerServ.hideLoader(this.$viewContainerRef, this.tabCounter);
        this.toastServ.showMultiLineError(error.error.Message, "Error");
      }
    );
  }
  setData(http: Observable<any>, message: string = null) {
    http.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      this._data = res;
      this.spinnerServ.hideLoader(this.$viewContainerRef, this.tabCounter);
      if (!FsUtil.checkNullOrUndefined([message], true))
        this.toastServ.success(message, "Success!");
    }, error => {
      this.spinnerServ.hideLoader(this.$viewContainerRef, this.tabCounter);
      if (!FsUtil.checkNullOrUndefined([error.error.Message]))
            this.toastServ.showMultiLineError(error.error.Message, "Error");
    });
  }
  onCancelAction(dataItem) {
    this.cancelSettings = { ID: dataItem["ID"], show: true };
  }
  onPostponeVisit(dataItem) {
    this.showPostponeModal = true;
    this.selectedVisit = { ID: dataItem.ID };
  }
  closePostponement(e) {
    this.showPostponeModal = false;
    this.selectedVisit = null;
    if (e) {
      let visit = this.data.Visits.find(x => x.ID == e.ID);
      if (visit)
        visit.AttemptCount = e.AttemptCount;
    }
  }
  onCancelVisitChange(e) {
    if (e.loader) {
      this.spinnerServ.showloader(this.$viewContainerRef, this.tabCounter, 0);
    }
    else {
      this.spinnerServ.hideLoader(this.$viewContainerRef, this.tabCounter);
    }
    if (e.dataUpdate) {
      let visit = this.data.Visits.find(x => x.ID == this.cancelSettings.ID);
      if (visit != undefined && visit.Status != undefined)
         visit.Status = "Cancelled";
    }
    this.cancelSettings.show = false;
  }
}
